import { render, staticRenderFns } from "./RegistrationFormWorkerJoin.vue?vue&type=template&id=7f8da9c0&"
import script from "./RegistrationFormWorkerJoin.vue?vue&type=script&lang=js&"
export * from "./RegistrationFormWorkerJoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports